import script from "./ActivityLog.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityLog.vue?vue&type=script&setup=true&lang=js"

import "./ActivityLog.vue?vue&type=style&index=0&id=6812011f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6812011f"]])

export default __exports__